import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';

import { UserOnboardingModule } from '@main-client/src/app/user-onboarding/user-onboarding.module';

import { AuthGuardService } from '@main-client/src/app/core/auth-guard.service';
import { UserOnboardingLegacyGuardService } from '@main-client/src/app/user-onboarding/user-onboarding-legacy-guard.service';

import { UserOnboardingViewComponent } from './user-onboarding-view.component';
import { UserOnboardingComponent } from '@main-client/src/app/user-onboarding/user-onboarding.component';

import { USER_ONBOARDING_ROUTE_PATHS } from '../user-onboarding.helper';

@NgModule({
  imports: [
    CommonModule,
    MatProgressBarModule,
    RouterModule.forChild([
      {
        path: '',
        component: UserOnboardingViewComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/signup',
          },
          {
            path: 'sign-up',
            pathMatch: 'prefix',
            redirectTo: '/signup',
          },
          {
            path: '',
            title: $localize`:@@userOnboarding.getStarted:Get Started`,
            canActivate: [AuthGuardService],
            children: [
              {
                canActivate: [UserOnboardingLegacyGuardService],
                path: USER_ONBOARDING_ROUTE_PATHS.hello,
                children: [],
              },
              {
                canActivate: [UserOnboardingLegacyGuardService],
                path: USER_ONBOARDING_ROUTE_PATHS.profile,
                children: [],
              },
              {
                path: USER_ONBOARDING_ROUTE_PATHS.hubs,
                component: UserOnboardingComponent,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.hubs,
                },
              },
              {
                component: UserOnboardingComponent,
                path: USER_ONBOARDING_ROUTE_PATHS.hubGoals,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.hubGoals,
                },
              },
              {
                component: UserOnboardingComponent,
                path: USER_ONBOARDING_ROUTE_PATHS.hubInterests,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.hubInterests,
                },
              },
              {
                component: UserOnboardingComponent,
                path: USER_ONBOARDING_ROUTE_PATHS.hubInteractions,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.hubInteractions,
                },
              },
              {
                component: UserOnboardingComponent,
                path: USER_ONBOARDING_ROUTE_PATHS.hubSegments,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.hubSegments,
                },
              },
              {
                component: UserOnboardingComponent,
                path: USER_ONBOARDING_ROUTE_PATHS.introGoals,
                data: {
                  viewMode: USER_ONBOARDING_ROUTE_PATHS.introGoals,
                },
              },
            ],
          },
        ],
      },
    ]),
    UserOnboardingModule,
  ],
  declarations: [UserOnboardingViewComponent],
  providers: [UserOnboardingLegacyGuardService],
})
export class UserOnboardingViewModule {}
